import { Component, ChangeDetectorRef, OnDestroy, signal } from "@angular/core";
import {
  ActiveCartFacade,
  Cart,
  MultiCartFacade,
} from "@spartacus/cart/base/root";
import { RoutingService } from "@spartacus/core";
import { UserAccountService } from "@spartacus/user/account/core";
import { debounceTime, filter, Observable, Subject, Subscription, takeUntil } from "rxjs";
import { KnBrCommonService } from "src/app/services/kn-br-common.service";
import { KnBrCartContextService } from "src/app/store/kn-br-cart-context/kn-br-cart-context.service";
import { Router } from "@angular/router";
import { CartProceedToCheckoutComponent } from "@spartacus/cart/base/components";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { KnBrCheckoutService } from "src/app/services/kn-br-checkout-service";
import { Store } from "@ngrx/store";
import { CartActions } from "@spartacus/cart/base/core";
import { CheckoutFlowService } from "src/app/knbr-dual-checkout/checkout-flow-service";
import { NgClass } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

@Component({
    selector: "knbr-cwt-cart-order-summary",
    templateUrl: "./cwt-cart-order-summary.component.html",
    styleUrls: ["./cwt-cart-order-summary.component.scss"],
    imports: [
        NgClass,
        ReactiveFormsModule,
        FormsModule,
    ],
})
export class CwtCartOrderSummaryComponent extends CartProceedToCheckoutComponent implements OnDestroy {
  // cart$: Observable<Cart>;
  allSubscriptions = new Subscription();
  user$ = this.userService.get();
  userEmail: string;
  poJobNumber: string = '';
  private destroy$ = new Subject<void>();
  placeOrderButtonDisabled = true;
  cartDeliveryMode;
  cartData: any
  disablePoNumber = false;
  cartRes: any;

  constructor(
    protected activeCartService: ActiveCartFacade,
    protected knBrCommonService: KnBrCommonService,
    protected knBrCartContextService: KnBrCartContextService,
    protected currentUserService: UserAccountService,
    protected multiCartService: MultiCartFacade,
    protected knbrCheckoutService: KnBrCheckoutService,
    protected routingService: RoutingService,
    protected checkoutFlowService: CheckoutFlowService,
    protected router: Router,
    private userService: UserAccountFacade,
    protected cd: ChangeDetectorRef,
    protected store: Store,
  ) {
    super(router, cd);
  }

  ngOnInit() {
    this.allSubscriptions.add(this.checkoutFlowService.cartCreditInfo$.subscribe(res => {
      this.disablePoNumber = res;
      this.cd.detectChanges();
    }))
    this.knbrCheckoutService.setPlaceOrderDisableFlag(true)
    this.checkoutFlowService.setCreditCardPaymentSuccess(false);
    this.allSubscriptions.add(
      this.knbrCheckoutService.getPlaceOrderDisableFlag().subscribe(res => {
        this.placeOrderButtonDisabled = res;
        this.cd.detectChanges();
      }
      )
    )

    this.activeCartService.reloadActiveCart();
     this.activeCartService.takeActive()
      .pipe(takeUntil(this.destroy$))
      .subscribe(cart => {
        if (cart?.purchaseOrderNumber) {
          this.poJobNumber = cart.purchaseOrderNumber;
          this.cd.detectChanges()
        }
        this.cartDeliveryMode = cart?.deliveryMode?.code
      });
    this.allSubscriptions.add(
      this.user$.subscribe((userInfo) => {
        if (userInfo && userInfo.uid) {
          this.userEmail = userInfo.uid;
          this.cd.detectChanges();
        }
      })
    );
    this.activeCartService.isStable().pipe(
      debounceTime(300), // waits for 300ms pause in emissions
      filter(Boolean)
    ).subscribe(() => this.getActiveCart());
  }
  getActiveCart() {
    this.activeCartService.takeActive().subscribe({
      next: (res: any) => {
          this.cartData = res
          this.knBrCommonService.isCartLoading.set(false)
          this.cd.detectChanges()
        this.cartRes = res;
      }
    });
  }
  navigate(url: string) {
    // On navigate to checkout page calling validatopn api and once the response is received calling the cart detail api
    // to reload the cart data, in case of quote reference we need to check this as some entries might be effected.
    // const cartId = this.draftOrder.code;
    // this.knBrCommonService.validateOnCheckout();
    this.routingService.goByUrl(url);
    // this.subscription.add(
    //   this.checkoutValidationResponse$.subscribe((res: any) => {
    //     this.knBrCartContextService.get$.subscribe((response) => {
    //       const cartId = response ? response : null;
    //       if (cartId) {
    //         this.currentUserService.get().subscribe((res) => {
    //             const userId = res.customerId;
    //             this.multiCartService.loadCart({ cartId, userId, extraData: { active: true },
    //           });
    //         });
    //       }
    //     });
    //     if (res?.errorMessage && res.errorMessage[0].error === 'QUOTE_REF_VALIDATE') {
    //       this.knBrCommonService.clearCheckoutValidationResponse();
    //     } else if (res) {
    //       this.knBrCommonService.clearCheckoutValidationResponse();
    //       this.routingService.goByUrl(url);
    //     }
    //   })
    // );
  }

  navigateToCheckOutUrl(deliveryModeValue, poNumber) {
    const trimmedValue = poNumber?.trim();

    if (trimmedValue) {
      this.knbrCheckoutService.setPoNumberOnCartPage(trimmedValue).subscribe({
        next: (response) => {
          this.goToCheckoutPage(deliveryModeValue);
        },
        error: (err) => {
          console.error("set po number API Error:", err);
        },
      });
    } else {
      this.goToCheckoutPage(deliveryModeValue);
    }
  }

  goToCheckoutPage(deliveryModeValue) {
    if (deliveryModeValue === "pickUp") {
      this.router.navigateByUrl("/checkout/pickup-person");
    } else if (deliveryModeValue === "delivery") {
      this.router.navigateByUrl("/checkout/delivery-address");
    }
  }

  isCheckoutPage() {
    const isCheckout = this.router.url.includes("/checkout/");
    return isCheckout;
  }
  // yet to be implemented after clicking place order button
  placeOrderClick() {
    this.knBrCommonService.showSpinner$.next(true);
    this.knbrCheckoutService.orderConfirmation(true, this.poJobNumber).subscribe({
      next: (orderResponse) => {
        this.knbrCheckoutService.setOrder(orderResponse);
        localStorage.removeItem('deliveryCompletedSteps');
        localStorage.removeItem('pickUpCompletedSteps');
        localStorage.removeItem('kn-br-cart-context');
        this.navigateToConfirmationPage()
        this.knBrCommonService.showSpinner$.next(false);
        this.store.dispatch(new CartActions.ClearCartState());
      },
      error: () => {
        this.knBrCommonService.showSpinner$.next(false);
      },
    });
  }

  navigateToConfirmationPage() {
    if (this.cartDeliveryMode === "pickUp") {
      this.router.navigateByUrl("/cwtorder-confirmation_pickup");
    } else if (this.cartDeliveryMode === "delivery") {
      this.router.navigateByUrl("/cwtorder-confirmation_delivery");
    }
  }

  ngOnDestroy(): void {
    this.allSubscriptions?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

}
